import Rete from "rete";
import { StringSocket,StringControl } from "../../rete-controls/StringControl.js"
import LabelNode from "../../rete-custom-nodes/LabelNode.vue"

export default class LabelComponent extends Rete.Component {
    constructor(){
        super("Label"); // name
        this.data.component = LabelNode;
        this._categories = ["Output Nodes", "tryMe"];

    }

    builder(node) {

        let numControl = new StringControl(this.editor,"string",false);
      
        return node
        .addControl(numControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = node.data;
        //console.log(this.name + " node.data=" + JSON.stringify(node.data));
        //console.log(this.name + " outputs=" + JSON.stringify(outputs));
    }
}
//ReteComponentStore.add(new NumberInputComponent());